import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Optional,
  Output
} from "@angular/core";
import { ControlContainer, FormGroup } from "@angular/forms";
import { numberUtil } from "src/app/util/number-util";

@Component({
  selector: "number-adjuster",
  templateUrl: "./number-adjuster.component.html",
  styleUrls: ["./number-adjuster.component.scss"]
})
export class NumberAdjusterComponent implements OnInit {
  @Input() public formGroup: FormGroup;
  @Input() public for: string;
  @Input() public step = 10;
  @Input() public suffix = "";
  @Input() public highlightButtons = true;
  @Input() public min: number;
  @Input() public enforceMultiplier = false;
  @Input() public digits: number = 2;

  @Output() public onInputBlur = new EventEmitter();

  @HostBinding("class.readonly")
  @Input()
  public readonly = false;

  constructor(@Optional() private _controlContainer: ControlContainer) {}

  ngOnInit() {
    if (!this.formGroup) {
      if (
        this._controlContainer &&
        this._controlContainer.control instanceof FormGroup
      ) {
        this.formGroup = <FormGroup>this._controlContainer.control;
      }
    }
  }

  public get currentValue() {
    return this.formGroup.get(this.for).value;
  }

  public get hasValue() {
    const count = this.currentValue;
    return count && count > 0;
  }

  public increment() {
    const count = this.currentValue;
    const step = this.step || 1;

    const newValue = step && this.enforceMultiplier
      ? Math.max(
          this.min != null ? Math.ceil(this.min / step) * step : 0,
          (Math.floor(count / step) + 1) * step
        )
      : (this.min != null && count < this.min ? this.min : count + step);

    this.formGroup.get(this.for).setValue(numberUtil.round(newValue, this.digits));
  }

  public decrement() {
    let count = this.currentValue;

    if (this.enforceMultiplier) {
      let removeCount = numberUtil.round(count % this.step, this.digits);
      if (removeCount > 0) {
        count -= removeCount;
      } else {
        count -= this.step;
      }
    } else {
      count -= this.step;
    }

    if (count <= 0) {
      count = null;
    }

    const newValue = numberUtil.round(count, this.digits);

    this.formGroup.get(this.for).setValue(newValue);
  }
}
